var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8833 14.1395C10.7929 15.1798 9.97338 16 8.96703 16H1.93407C0.867446 16 0 15.0821 0 13.9535V5.02326C0 3.95833 0.775103 3.09127 1.75824 2.99557V10.9767C1.75824 12.7206 3.09887 14.1395 4.74725 14.1395H10.8833ZM13.7143 4.09302V10.9767C13.7143 12.1054 12.8468 13.0233 11.7802 13.0233H4.74725C3.68063 13.0233 2.81319 12.1054 2.81319 10.9767V2.04651C2.81319 0.917879 3.68063 0 4.74725 0H9.84615V3.53488C9.84615 3.84305 10.0824 4.09302 10.3736 4.09302H13.7143ZM10.9011 9.48837C10.9011 9.1802 10.6649 8.93023 10.3736 8.93023H6.15385C5.86261 8.93023 5.62637 9.1802 5.62637 9.48837C5.62637 9.79654 5.86261 10.0465 6.15385 10.0465H10.3736C10.6649 10.0465 10.9011 9.79654 10.9011 9.48837ZM10.9011 6.51163C10.9011 6.20346 10.6649 5.95349 10.3736 5.95349H6.15385C5.86261 5.95349 5.62637 6.20346 5.62637 6.51163C5.62637 6.8198 5.86261 7.06977 6.15385 7.06977H10.3736C10.6649 7.06977 10.9011 6.8198 10.9011 6.51163ZM10.9011 0.32707V2.97674H13.4052L10.9011 0.32707Z",
    fill: "#626262"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copy_icon.0e20c5d49002f24c8d02453c2de1523a.svg";
export { ForwardRef as ReactComponent };